module Meevo.Plugins.AppointmentBook {
    class CancellationFeeConfirmationController {
        actions: any;
        helper: any;

        static $inject = ['appointmentBookActionsService', 'appointmentBookHelperService', 'appointmentBookModalService', '$scope', 'message'];

        constructor(actions, helper, modal, $scope, message: string) {

            $scope.message = message;

            $scope.launchRegister = function () {
                modal.hideModal(Model.MessageBoxButtonResult.Yes);
            }
            $scope.cancel = function() {
                modal.hideModal( Model.MessageBoxButtonResult.Cancel);
            }

        }

    }

    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.CancellationFeeConfirmationController", CancellationFeeConfirmationController);
}